module.exports = __webpack_public_path__ + "static/media/merch05142022_2.9b3bc2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/merch05142022_2.jpg
// module id = 295
// module chunks = 0